import axiosInstance from './axios';

let interceptorId = null;
let isLoggingOut = false;

const setupAxiosInterceptors = (authContext) => {
    if (interceptorId !== null) {
        axiosInstance.interceptors.response.eject(interceptorId);
    }

    interceptorId = axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const data = error?.response?.data;

            if (status === 401) {
                forceLogout(authContext, data);
            }

            return Promise.reject(error);
        }
    );
};

const forceLogout = (authContext, reason) => {
    if (isLoggingOut) {
        return;
    }

    isLoggingOut = true;

    console.warn('Sessão expirada ou token inválido:', reason);

    if (authContext?.setAuth) {
        authContext.setAuth({});
    }

    localStorage.removeItem('auth');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('user');

    sessionStorage.clear();

    window.location.replace('/login?sessionExpired=1');
};

export default setupAxiosInterceptors;